module.exports = __webpack_public_path__ + "static/media/HINDUNILVR_F1.8e17f6f9.txt";